import { Tabs } from "antd";
import React, { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { SectionSetting } from "../../../core/json/SectionSetting";
import {
  addSectionSettings,
  getSectionSetting,
  getKOTPrinterList,
} from "../../../services/MasterApiServices";
import toast from "react-hot-toast";
import { SectionSettingViewModel } from "../../../core/json/SectionSettingViewModal";
import { SectionClass } from "../../../core/json/SectionClass";
import { TaxClass } from "../../../core/json/TaxClass";
const { TabPane } = Tabs;

function SectionSettings({ data, selectedSection }) {
  const [kotPrinterList, setKotPrinterList] = React.useState([]);
  const { taxList } = useSelector((state) => state.usersetting);
  const { branch } = useSelector((state) => state.branchlist);
  const { userId } = useSelector((state) => state.userauth);
  const { branchsettings } = useSelector((state) => state.settings);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });
  useEffect(() => {
    if (data) {
      setValue("enableKOTPrinting", data.enableKOTPrinting);
      setValue("printKOTInSalesFormat", data.printKOTInSalesBillFormat);
      setValue("printKOTInSalesBillPrinter", data.printKOTInSalesBillPrinter);
      setValue("printBothSalesAndKOT", data.printBothSalesAndKOTPrint);
      setValue(
        "showpopuptocapturecustomerdetail",
        data.showPopupToCaptureCustomerDetail
      );
      setValue("showpopuptoselectwaiter", data.showPopupToSelectWaiter);
      setValue("showpopuptoselecttable", data.showPopupToSelectTable);
      setValue("printfilename", data.printFileName);
      setValue("numberOfInvoicePrints", data ? data.numberOfInvoicePrints : 0);
      setValue("billstartnumber", data.billStartNumber || 0);
      setValue("invoiceprefix", data.invoicePrefix || " ");
      setValue("tax", data?.tax ? data?.tax.guid : " ");
      setValue("isChairEnabled", data?.isChairEnabled);
      setValue("isPaxEnabled", data?.isPaxEnabled);
      setValue("isMultiOrderEnabled", data?.isMultiOrderEnabled);
      setValue("isCashButtonPrint", data?.isCashButtonPrint ?? true);
      setValue("isPayScreenPrintOnSettle", data?.isPayScreenPrintOnSettle ?? false);
      setValue("isKitchenManagerPrintEnabled", data?.isKitchenManagerPrintEnabled ?? false);
      setValue("kitchenManagerPrinterID", data?.kitchenManagerPrinterID ?? "");
      setValue("invoicePrinterID", data?.invoicePrinterID || "");
      setValue("deliveryPrinterID", data?.deliveryPrinterID || "");
    }
    setValue("branch", data?.branch?.guid);
  }, [data, selectedSection]);

  useEffect(() => {
    getKOTPrinterList()
      .then((res) => setKotPrinterList(Array.isArray(res) ? res : res?.data || []))
      .catch(() => setKotPrinterList([]));
  }, []);

  const handleReset = () => {
    reset();
  };

  console.log(watch().numberOfInvoicePrints);

  const handleFormSubmit = async (formData) => {
    const objsectionsettings = new SectionSetting();
    const objsection = new SectionClass();
    const objtax = new TaxClass();
    objtax.guid = null;
    objsection.Branch = branch;
    objsection.guid = selectedSection.guid;
    objsection.name = selectedSection.name;
    objsectionsettings.Section = objsection;
    objsectionsettings.id = selectedSection.id;
    objsectionsettings.EnableKOTPrinting = formData.enableKOTPrinting;
    objsectionsettings.PrintKOTInSalesBillFormat =
      formData.printKOTInSalesFormat;
    objsectionsettings.PrintKOTInSalesBillPrinter =
      formData.printKOTInSalesBillPrinter;
    objsectionsettings.PrintBothSalesAndKOTPrint =
      formData.printBothSalesAndKOT;
      objsectionsettings.isChairEnabled = formData.isChairEnabled;
      objsectionsettings.isPaxEnabled = formData.isPaxEnabled;
      objsectionsettings.isMultiOrderEnabled = formData.isMultiOrderEnabled;
    objsectionsettings.IsCashButtonPrint = formData.isCashButtonPrint ?? true;
    objsectionsettings.IsPayScreenPrintOnSettle = formData.isPayScreenPrintOnSettle ?? false;
    objsectionsettings.IsKitchenManagerPrintEnabled = formData.isKitchenManagerPrintEnabled ?? false;
    objsectionsettings.KitchenManagerPrinterID = formData.kitchenManagerPrinterID || null;
    objsectionsettings.InvoicePrinterID = formData.invoicePrinterID || null;
    objsectionsettings.DeliveryPrinterID = formData.deliveryPrinterID || null;
    objsectionsettings.ShowPopupToCaptureCustomerDetail =
      formData.showpopuptocapturecustomerdetail;
    objsectionsettings.ShowPopupToSelectWaiter =
      formData.showpopuptoselectwaiter;
    objsectionsettings.ShowPopupToSelectTable = formData.showpopuptoselecttable;
    objsectionsettings.PrintFileName = formData.printfilename;
    objsectionsettings.NumberOfInvoicePrints = Number(
      formData.numberOfInvoicePrints
    );
    objsectionsettings.BillStartNumber = Number(formData.billstartnumber);
    objsectionsettings.InvoicePrefix = formData.invoiceprefix;
    objsectionsettings.Tax =
      taxList?.find((e) => e.guid == formData.tax) || objtax;
    objsectionsettings.TaxGuid = formData.tax || null;
    objsectionsettings.PrintTempFile = null;
    objsectionsettings.updatedUser = `{${userId?.id}}`;
    objsectionsettings.createdUser = `{${userId?.id}}`;

    try {
      const response = await addSectionSettings(objsectionsettings);
      if (response == true) {
        // fields.forEach((_, index) => remove(index))
        toast.success("success");
        closemodal();
      } else {
        toast.error(response);
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message);
      console.error("Error handling Section:", error?.response?.data?.Message);
    }
  };
  const closeButtonRef = useRef();

  const closemodal = () => {
    if (closeButtonRef.current) {
      closeButtonRef.current.click();
    }
  };
  return (
    <div className="modal fade" tabIndex="-1" id="sectionsettings">
      <div className="modal-dialog purchase modal-dialog-centered stock-adjust-modal">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h3>Section settings ({selectedSection?.name})</h3>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  ref={closeButtonRef}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <form
                className="col-12 align-items-center justify-content-between p-5"
                onSubmit={handleSubmit(handleFormSubmit)}
              >
                {errors?.printfilename?.type === "required" && (
                  <span className="text-danger">
                    * Print Filename is required
                  </span>
                )}
                <Tabs defaultActiveKey="1">
                  <TabPane tab="Printing Settings" key="1">
                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <input
                          type="checkbox"
                          {...register("enableKOTPrinting")}
                        />
                        Enable KOT Printing
                      </div>
                      <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        When this setting is enabled, a KOT print will be
                        generated in the kitchen.
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <input
                          type="checkbox"
                          {...register("printKOTInSalesFormat")}
                        />
                        Print KOT in sales bill format
                      </div>
                      <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        A KOT print will contain only the name and quantity of
                        food to be prepared. If the option Print KOT in sales
                        bill format is selected, KOT print will contain
                        additional details similar to the sales bill.
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <input
                          type="checkbox"
                          {...register("printKOTInSalesBillPrinter")}
                        />
                        Print KOT in sales bill printer
                      </div>
                      <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        Selecting this option will print both KOT and sales bill
                        on the receipt printer.
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <input
                          type="checkbox"
                          {...register("printBothSalesAndKOT")}
                        />
                        Print both sales and KOT print
                      </div>
                      <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        This option will print both sales and KOT when an order
                        is saved or cashed for the section, commonly used for
                        delivery sections.
                      </div>
                    </div>

                    <div className="row">
                       <div className="col-lg-3 col-md-6 col-sm-12">
                        <input
                          type="checkbox"
                          {...register("isChairEnabled")}
                        />
                        Enable Chair
                      </div>
                          <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        If enabled, chair management will be activated for this section.
                      </div>
</div>
                    <div className="row">
                       <div className="col-lg-3 col-md-6 col-sm-12">
                        <input
                          type="checkbox"
                          {...register("isPaxEnabled")}
                        />
                        Enable Pax
                      </div>
                         <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        If enabled, pax (number of people) management will be activated for this section.
                        </div>
</div>
                    <div className="row">
                       <div className="col-lg-3 col-md-6 col-sm-12">
                        <input
                          type="checkbox"
                          {...register("isMultiOrderEnabled")}
                        />
                        Enable Multi-Order
                      </div>
                           <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        If enabled, multiple orders can be taken simultaneously for this section.
                      </div>
                      </div>

                    {/* Receipt printing */}
                    <div className="row mt-3">
                      <div className="col-12"><strong>Receipt Printing</strong></div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <input type="checkbox" {...register("isCashButtonPrint")} />
                        {" "}Auto-print receipt when Cash button pressed
                      </div>
                      <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        When enabled, a receipt is automatically printed when the cashier presses the Cash button on the POS screen.
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <input type="checkbox" {...register("isPayScreenPrintOnSettle")} />
                        {" "}Print invoice when bill is fully settled
                      </div>
                      <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        When enabled, a receipt is automatically printed when a bill is fully settled on the Pay Screen.
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="input-blocks">
                          <label>TAB Invoice Printer</label>
                          <select className="form-control" {...register("invoicePrinterID")}>
                            <option value="">— None (use default) —</option>
                            {kotPrinterList.map((p) => (
                              <option key={p.guid} value={p.guid}>{p.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="input-blocks">
                          <label>Dispatch Printer</label>
                          <select className="form-control" {...register("deliveryPrinterID")}>
                            <option value="">— None —</option>
                            {kotPrinterList.map((p) => (
                              <option key={p.guid} value={p.guid}>{p.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* Kitchen Manager printer */}
                    <div className="row mt-3">
                      <div className="col-12"><strong>Kitchen Manager Printer</strong></div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <input type="checkbox" {...register("isKitchenManagerPrintEnabled")} />
                        {" "}Enable Kitchen Manager printer
                      </div>
                      <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        When enabled, a copy of the KOT is also sent to a dedicated kitchen manager printer (separate from the regular KOT printer).
                      </div>
                    </div>

                    {watch("isKitchenManagerPrintEnabled") && (
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="input-blocks">
                            <label>Kitchen Manager Printer</label>
                            <select className="form-control" {...register("kitchenManagerPrinterID")}>
                              <option value="">— None —</option>
                              {kotPrinterList.map((p) => (
                                <option key={p.guid} value={p.guid}>
                                  {p.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="input-blocks">
                          <label>No.of invoice prints</label>
                          <input
                            className="form-control"
                            type="number"
                            min={0}
                            defaultValue={0}
                            id="name"
                            {...register("numberOfInvoicePrints")}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="input-blocks">
                          <label>
                            Print Format Name
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.printfilename ? " border-danger" : ""
                            }`}
                            type="text"
                            min={0}
                            {...register("printfilename", { required: true })}
                          />
                        </div>
                      </div>
                    </div> 
                  </TabPane>

                  <TabPane tab="Others" key="2">
                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <input
                          type="checkbox"
                          {...register("showpopuptocapturecustomerdetail")}
                        />
                        Show popup to capture customer detail
                      </div>
                      <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        If enabled, a popup is shown to capture the customer
                        detail or vehicle numbers whom the food to be delivered.
                        This is normally used when customers cannot walkin/enter
                        into the restaurant
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <input
                          type="checkbox"
                          {...register("showpopuptoselectwaiter")}
                        />
                        Show popup to enter waiter information
                      </div>
                      <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        If enabled, a popup is shown to capture the waiter
                        information. Detail of waiter who takes the order
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <input
                          type="checkbox"
                          {...register("showpopuptoselecttable")}
                        />
                        Show popup to enter table information
                      </div>
                      <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
                        If enabled, a popup is shown to capture information
                        (number or other identifiers) of the table where the
                        order being taken for
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="input-blocks">
                          <label>Bill Start Number</label>
                          <input
                            className="form-control"
                            type="number"
                            min={0}
                            defaultValue={0}
                            id="name"
                            {...register("billstartnumber")}
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="input-blocks">
                          <label>Invoice Prefix</label>
                          <input
                            className="form-control"
                            type="text"
                            min={0}
                            id="name"
                            {...register("invoiceprefix")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      {branchsettings.disableTaxInSale == false && (
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="input-blocks">
                            <label>Tax</label>
                            <select
                              {...register("tax")}
                              className=" form-control"
                            >
                              <option value="t" disabled>
                                Select Tax
                              </option>
                              {taxList?.map((category) => (
                                <option
                                  key={category.guid}
                                  value={category.guid}
                                >
                                  {category.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}
                    </div>
                  </TabPane>
                </Tabs>
                <div className="col-lg-12">
                  <div className="modal-footer-btn">
                    <button
                      type="button"
                      className="btn btn-cancel me-2"
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                    <button type="submit" className="btn btn-save">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionSettings;
